import type { LiabilityFormLayout } from "../types";

export const liabilityInterestRateLayout = (): LiabilityFormLayout => {
  return {
    render: 'interestRate'
  }
}
